module.exports = __webpack_public_path__ + "media/images/illustrations/404-error-with-a-cute-animal-d10f58c0f275d2517742888583f48bfb.svg";